const BagLink = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1C13.7913 1 12 2.79128 12 5V13H10V5C10 1.68672 12.6867 -1 16 -1C19.3133 -1 22 1.68672 22 5V13H20V5C20 2.79128 18.2087 1 16 1Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3643 16.6361C27.4116 14.6835 24.2458 14.6835 22.2932 16.6361L20.1719 18.7574L21.5861 20.1716L23.7074 18.0503C24.879 16.8787 26.7785 16.8787 27.9501 18.0503C29.1216 19.2219 29.1216 21.1214 27.9501 22.293L25.8287 24.4143L27.2429 25.8285L29.3643 23.7072C31.3169 21.7545 31.3169 18.5887 29.3643 16.6361Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6364 29.3638C14.6837 27.4112 14.6837 24.2454 16.6364 22.2927L18.7577 20.1714L20.1719 21.5856L18.0506 23.7069C16.879 24.8785 16.879 26.778 18.0506 27.9496C19.2221 29.1212 21.1216 29.1212 22.2932 27.9496L24.4145 25.8283L25.8287 27.2425L23.7074 29.3638C21.7548 31.3164 18.589 31.3164 16.6364 29.3638Z"
        fill={color}
      />
      <path
        d="M5.0001 7V14.8861L2.87369 24.1006C2.29528 26.607 4.19891 29 6.77125 29H13.9294C12.5934 26.3718 13.0243 23.0763 15.222 20.8786L20.8789 15.2219C22.5448 13.556 24.8415 12.9053 27.0001 13.2698V7H5.0001Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5861 25.8284L20.1719 24.4142L24.4146 20.1716L25.8288 21.5858L21.5861 25.8284Z"
        fill={color}
      />
    </svg>
  );
};
export default BagLink;
